module.exports = __webpack_public_path__ + "img/gzh.25b6127b.jpg";